"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var ServiceItem = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ServiceItem, _Vue);
  var _super = (0, _createSuper2.default)(ServiceItem);
  function ServiceItem() {
    var _this;
    (0, _classCallCheck2.default)(this, ServiceItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "service", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isSelected", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visibleSelect", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unCheckImg", require("@/assets/images/oval.png"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkImg", require("@/assets/images/check.png"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "avatarDefault", require("@/assets/images/avatar_default.svg"));
    return _this;
  }
  (0, _createClass2.default)(ServiceItem, [{
    key: "onClick",
    value: function onClick() {
      return this.service;
    }
  }]);
  return ServiceItem;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ServiceItem.prototype, "service", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], ServiceItem.prototype, "isSelected", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], ServiceItem.prototype, "visibleSelect", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("onClick")], ServiceItem.prototype, "onClick", null);
ServiceItem = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ServiceItem);
var _default = ServiceItem;
exports.default = _default;